<template>
<div>
  <b-modal ref="projectsAccountModalRef" id="projectsAccountModalRef" :hide-footer="true" title="Selecione um projeto para replicar os dados de Conta" size="lg" :hide-header="false">
    <div class="modal-projects-list">
      <div v-if="loadingProjects">
        <h6>Aguarde, carregando projetos...</h6>
      </div>
      <ul v-else>
        <li v-for="p in projects" :key="p.ProjectId">
          <a v-if="p.PagarmeAccount" href="#" @click.stop.prevent="selectProjectAccount(p)">
            <span>{{(p.Info) ? p.Info.title : 'Sem Título'}}</span>
              <p>Código do Banco: {{p.PagarmeAccount.bankAccountCode}} - Agência: {{p.PagarmeAccount.bankAccountAgency + '-' + p.PagarmeAccount.bankAccountAgencyDv}}</p>
              <p>Conta Corrente: {{p.PagarmeAccount.bankAccountAccount + '-' + p.PagarmeAccount.bankAccountAccountDv}}</p>
              <p>Titular: {{p.PagarmeAccount.bankAccountLegalName}} - CPF/CNPJ: {{p.PagarmeAccount.bankAccountDocumentNumber}}</p>
          </a>
          <a href="#" v-else @click.stop.prevent="showAlert()">
            <span>{{(p.Info) ? p.Info.title : 'Sem Título'}}</span>
              <p>Projeto não possui conta cadastrada.</p>
          </a>
        </li>
      </ul>
    </div>
  </b-modal>
  <div class="row" v-if="projects && projects.length > 0">
    <div class="col-md-8"></div>
    <div class="col-md-4">
      <button v-b-modal.projectsAccountModalRef class="btn">Copiar de outro projeto</button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <h4>Transferência bancária</h4>
      <span>Atenção: preenchimento obrigatório para recebimento de doações através de boleto bancário e cartões de crédito 
        (Doações realizadas através do PayPal serão creditadas diretamente na respectiva conta do PayPal da Organização Social)</span>
    </div>

    <div class="col-md-8">
      <form>
        <div class="row">
          <div class="form-group col-sm">
            <label>Código do banco</label>
            <input class="form-control" v-model="bankCode" />
          </div>
          <div class="col-sm">
            <a class="link-bank-codes" href="http://www.bcb.gov.br/pom/spb/estatistica/port/ASTR003.pdf" target="_blank">Pesquisar</a>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-4">
            <label>Agência</label>
            <input type="number" class="form-control" v-model="agency"/>
          </div>
          <div class="form-group col-sm-2">
            <label>&nbsp;</label>
            <input type="number" class="form-control" v-model="agencyCode"/>
          </div>
          <div class="form-group col-sm-4">
            <label>Conta Corrente</label>
            <input type="number" class="form-control" v-model="account"/>
          </div>
          <div class="form-group col-sm-2">
            <label>&nbsp;</label>
            <input type="number" class="form-control" v-model="accountCode"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-8">
            <label>Tipo de conta</label>
            <b-form-select class="mb-3" v-model="accountType">
              <option value="conta_corrente">Conta Corrente</option>
              <option value="conta_poupanca">Conta Poupança</option>
              <option value="conta_corrente_conjunta">Conta Corrente conjunta</option>
              <option value="conta_poupanca_conjunta">Conta Poupança conjunta</option>
            </b-form-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm">
            <label>Nome do titular da conta</label>
            <input type="text" class="form-control" v-model="holder" maxlength="30"/>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm">
            <label>CNPJ da ONG</label>
            <input v-mask="'##.###.###/####-##'" type="text" class="form-control" placeholder="Somente números" v-model="cpfCnpj"/>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <button v-on:click.stop.prevent="save()" class="btn">Salvar dados bancários</button>
    </div>
    <div class="col-md-8">
      <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{msg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div v-if="showSuccessMsg" class="alert alert-success alert-dismissible fade show" role="alert">
        {{successMsg}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMessage()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import {mask} from 'vue-the-mask'

export default {
  name: 'ProjectBankInfo',
  props: ['project'],
  directives: {mask},
  components: {

  },
  data(){
    return {
      msg: '',
      successMsg: '',
      loadingProjects: true,
      projects: null,
      showMsg: false,
      showSuccessMsg: false,
      projectId: null,
      bankCode: null,
      agency: null,
      agencyCode: null,
      account: null,
      accountCode: null,
      accountType: null,
      holder: null,
      cpfCnpj: null,
      page: 'bank-account'
    }
  },
  mounted (){
    this.projectId = this.project.ProjectId;
    if(this.project.PagarmeAccount){
      this.bankCode = (this.project.PagarmeAccount.bankAccountCode != "NULL") ? this.project.PagarmeAccount.bankAccountCode : null;
      this.agency = (this.project.PagarmeAccount.bankAccountAgency != "NULL") ? this.project.PagarmeAccount.bankAccountAgency : null;
      this.agencyCode = (this.project.PagarmeAccount.bankAccountAgencyDv != "NULL") ? this.project.PagarmeAccount.bankAccountAgencyDv : null;
      this.account = (this.project.PagarmeAccount.bankAccountAccount != "NULL") ? this.project.PagarmeAccount.bankAccountAccount : null;
      this.accountCode = (this.project.PagarmeAccount.bankAccountAccountDv != "NULL") ? this.project.PagarmeAccount.bankAccountAccountDv : null;
      this.accountType = (this.project.PagarmeAccount.bankAccountType != "NULL") ? this.project.PagarmeAccount.bankAccountType : null;
      this.holder = (this.project.PagarmeAccount.bankAccountLegalName != "NULL") ? this.project.PagarmeAccount.bankAccountLegalName : null;
      this.cpfCnpj = (this.project.PagarmeAccount.bankAccountDocumentNumber != "NULL") ? this.project.PagarmeAccount.bankAccountDocumentNumber : null;
    }
    this.getProjects();
  },
  methods: {
    getProjects(){
      this.$http.get(API.Profile.projects, {headers: auth.getHeaders()}).then((result) => {
        this.loadingProjects = false;
        this.projects = result.body.projects
        if(this.projects){
          var projectId = this.projectId
          this.projects = this.projects.filter((p) => {
            return p.ProjectId != projectId
          })
        }
      });
    },
    selectProjectAccount(p){
      this.$refs.projectsAccountModalRef.hide();
      if(p.PagarmeAccount){
        this.bankCode = (p.PagarmeAccount.bankAccountCode != "NULL") ? p.PagarmeAccount.bankAccountCode : null;
        this.agency = (p.PagarmeAccount.bankAccountAgency != "NULL") ? p.PagarmeAccount.bankAccountAgency : null;
        this.agencyCode = (p.PagarmeAccount.bankAccountAgencyDv != "NULL") ? p.PagarmeAccount.bankAccountAgencyDv : null;
        this.account = (p.PagarmeAccount.bankAccountAccount != "NULL") ? p.PagarmeAccount.bankAccountAccount : null;
        this.accountCode = (p.PagarmeAccount.bankAccountAccountDv != "NULL") ? p.PagarmeAccount.bankAccountAccountDv : null;
        this.accountType = (p.PagarmeAccount.bankAccountType != "NULL") ? p.PagarmeAccount.bankAccountType : null;
        this.holder = (p.PagarmeAccount.bankAccountLegalName != "NULL") ? p.PagarmeAccount.bankAccountLegalName : null;
        this.cpfCnpj = (p.PagarmeAccount.bankAccountDocumentNumber != "NULL") ? p.PagarmeAccount.bankAccountDocumentNumber : null;
      }
    },
    save(){
      // alert("Função em manutenção. Tente novamente mais tarde.");
      var r = confirm("Confirma todos os dados bancários? Suas informações serão atualizadas.");
      if(r == true){
        this.showMsg = false;
        this.showSuccessMsg = false;
        this.$emit('showloading');
        if(this.validate()){
          var cpfCnpj = this.cpfCnpj.replace(/\D/g,'');
          this.$http.post(API.Projects.updateProject + this.projectId, {page: this.page, bankCode: this.bankCode, agency: this.agency, agencyCode: this.agencyCode, account: this.account,
            accountCode: this.accountCode, accountType: this.accountType, holder: this.holder, cpfCnpj: cpfCnpj}, {headers: auth.getHeaders()}).then((res) => {
              if(res.body.success === true){
                this.successMsg = res.body.message;
                this.showSuccessMsg = true;
                this.$emit('reload');
              }else{
                this.showMessage(res.body.message);
              }
              this.$emit('hideloading');
            }, (err) => {
              console.log(err)
              this.showMessage('Erro ao processar requisição.');
              this.$emit('hideloading');
            });
        }else{
          this.$emit('hideloading');
        }
      }
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.successMsg = "";
      this.msg = "";
      this.showMsg = false;
      this.showSuccessMsg = false;
    },
    showAlert(){
      alert("Projeto não possui conta cadastrada!");
    },
    validate(){
      if(this.bankCode == '' || this.bankCode == null){
        this.showMessage("Insira o código do banco.");
        return false;
      }
      if(this.agency == '' || this.agency == null){
        this.showMessage("Insira o número da agência. Caso possua dígito, preencha no campo apropriado.");
        return false;
      }
      if(this.account == '' || this.account == null){
        this.showMessage("Insira o número da conta. Caso possua dígito, preencha no campo apropriado.");
        return false;
      }
      if(this.accountType == '' || this.accountType == null){
        this.showMessage("Informe o tipo da conta.");
        return false;
      }
      if(this.accountType == '' || this.accountType == null){
        this.showMessage("Informe o tipo da conta.");
        return false;
      }
      if(this.holder && this.holder.length > 30){
        this.showMessage("Nome legal deve ter no máximo 30 caracteres.");
        return false;
      }
      if(this.cpfCnpj == '' || this.cpfCnpj == null){
        this.showMessage("Informe o documento (CPF ou CNPJ) do titular da conta.");
        return false;
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}

.link-bank-codes{
  color: #00AE39;
  font-weight: bold;
  display: block;
  width: 100%;
  font-size: 22px;
  margin-top: 30px;
  text-decoration: none;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.modal-projects-list{
  ul{
    list-style: none;
    padding: 0px;
    li{
      border: thin solid #ccc;
      border-radius: 10px;
      margin-top: 20px;
      &:first-child{
        margin-top: 0px;
      }
      a{
        text-decoration: none;
        color: #666;
        display: block;
        padding: 10px;

        span{
          font-weight: bold;
          font-size: 22px;
        }
      }
      &:hover{
        border: thin solid #00AE39;
        a{
          color: #00AE39;
          font-weight: bold;
        }
      }
    }
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/BankInfo.vue